<template>
  <div class="detail">
    <div class="detail-header">
      <div class="detail-header-text">
        <h3>项目详情</h3>
        <p>随时随地为您提供智能的解决方案</p>
      </div>
    </div>
    <div class="detail-background">
      <div class="detail-content">
        <div class="detail-content-top">
          <div class="detail-content-top-left">
            <img src="../assets/default.png" alt="" />
            <span>{{ ruleForm.creatorName }}</span>
          </div>

          <div class="detail-content-top-right">
            <div class="detail-content-top-right-head">
              <div class="title-wrap">
                <p class="category-label">
                  {{
                    ruleForm.type == 1
                      ? "广告策划"
                      : ruleForm.type == 2
                      ? "企业咨询"
                      : ruleForm.type == 3
                      ? "数字内容制作"
                      : "系统平台搭建"
                  }}
                </p>
                <h1>{{ ruleForm.projectName }}</h1>
              </div>
              <div
                class="status-badge"
                :class="{
                  pending: ruleForm.status == 0,
                  pass: ruleForm.status == 1,
                  reject: ruleForm.status == 2,
                }"
              >
                {{
                  ruleForm.status == 0
                    ? "待审核"
                    : ruleForm.status == 1
                    ? "审核通过"
                    : "审核驳回"
                }}
              </div>
            </div>

            <div class="detail-grid">
              <div class="info-card desc-card">
                <label>项目描述</label>
                <span>{{ ruleForm.projectDescribe }}</span>
              </div>
              <div class="info-card">
                <label>项目预算</label>
                <span class="highlight">{{ ruleForm.projectSpendStr }}</span>
              </div>
              <div class="info-card">
                <label>交付周期</label>
                <span>{{ ruleForm.expectDay }}天</span>
              </div>
              <div class="info-card">
                <label>联系人</label>
                <span>{{ ruleForm.contacts }}</span>
              </div>
              <div class="info-card">
                <label>联系方式</label>
                <span>{{ ruleForm.contactPhone }}</span>
              </div>
              <div class="info-card full">
                <label>联系地址</label>
                <span>{{ ruleForm.contactAdd }}</span>
              </div>
            </div>
          </div>
        </div>
        <em v-if="ruleForm.proPicList.length > 0"></em>
        <div
          class="detail-content-imgList"
          v-if="ruleForm.proPicList.length > 0"
        >
          <div
            class="detail-content-imgList-item"
            v-for="(item, index) in ruleForm.proPicList"
            :key="index"
          >
            <img :src="item" alt="" />
            <span class="mask">
              <img
                src="../assets/zoom.png"
                class="zoom"
                @click="(previewUrl = item), (previewDia = true)"
              />
            </span>
          </div>
        </div>
        <div class="detail-send">
          <div class="detail-content-send" @click="$router.go(-1)">返回</div>
          <!-- <div class="detail-content-await" @click="reCords(0)">待审核</div> -->
          <div class="detail-content-pass" @click="reCords(1)">审核通过</div>
          <div class="detail-content-reject" @click="reCords(2)">审核驳回</div>
        </div>
      </div>
    </div>
    <el-dialog
      title=""
      custom-class="preview"
      :visible.sync="previewDia"
      width="800px"
    >
      <img :src="previewUrl" alt="" style="width: 100%; height: 100%" />
    </el-dialog>
  </div>
</template>

<script>
import { prjIntroGetAuditeProject } from "../utils/records";
export default {
  name: "topsubmit",
  components: {},
  data() {
    return {
      ruleForm: {
        proPicList: [],
      },
      previewDia: false,
      previewUrl: "",
      rules: {
        type: [
          { required: true, message: "请选择项目类型", trigger: "change" },
        ],
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
        projectSpend: [
          { required: true, message: "请选择预算范围", trigger: "change" },
        ],
        projectDescribe: [
          { required: true, message: "请输入项目描述", trigger: "blur" },
        ],
        expectDay: [
          { required: true, message: "请输入期望交付周期", trigger: "blur" },
        ],
        contactPhone: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
        ],
        // leaveNote: [
        //   { required: true, message: '请输入留言', trigger: 'blur' },
        // ],
      },
      options: [
        {
          label: "3万以下",
          value: "1",
        },
        {
          label: "3万-10万",
          value: "2",
        },
        {
          label: "10万-50万",
          value: "3",
        },
        {
          label: "50万以上",
          value: "4",
        },
      ],
      options2: [
        {
          label: "广告策划",
          value: 1,
        },
        {
          label: "企业咨询",
          value: 2,
        },
        {
          label: "数字内容制作",
          value: 3,
        },
        {
          label: "系统平台搭建",
          value: 4,
        },
      ],
    };
  },
  methods: {
    reCords(status) {
      prjIntroGetAuditeProject({
        id: this.ruleForm.id,
        status: status,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: res.data.message,
            type: "success",
          });
          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
        }else{
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },
  },
  activated() {
    console.log(decodeURIComponent(this.$route.query.item));
    if (this.$route.query.item) {
      this.ruleForm = JSON.parse(decodeURIComponent(this.$route.query.item));
    }
  },
};
</script>
<style scoped lang="less">
.normal() {
  display: flex;
  align-items: center;
}
.fontdemo(@size,@family,@weight,@color) {
  font-size: @size;
  font-family: @family;
  font-weight: @weight;
  color: @color;
}
.detail {
  width: 100%;
  background: #0c0c0c;

  &-header {
    width: 100%;
    min-height: 440px;
    padding: 0 100px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    position: relative;
    overflow: hidden;
    background:
      linear-gradient(90deg, rgba(10, 10, 10, 0.94) 0%, rgba(10, 10, 10, 0.72) 42%, rgba(10, 10, 10, 0.32) 100%),
      url("../assets/detail.png") no-repeat center center;
    background-size: cover;

    &::after {
      content: "";
      position: absolute;
      left: 100px;
      right: 100px;
      bottom: 74px;
      height: 1px;
      background: linear-gradient(90deg, rgba(249, 201, 46, 0.95), rgba(249, 201, 46, 0.08));
    }

    &-text {
      position: relative;
      z-index: 1;
      max-width: 760px;
      padding-left: 28px;
      border-left: 4px solid #f9c92e;

      h3 {
        .fontdemo(48px, "PingFangSC,PingFang SC", 600, #ffffff);
        margin: 0;
        text-align: left;
        line-height: 1.2;
      }
      p {
        .fontdemo(20px, "PingFangSC,PingFang SC", 400, rgba(255,255,255,0.7));
        margin: 18px 0 0;
        max-width: 700px;
        line-height: 1.8;
        text-align: left;
      }
    }
  }
  &-background {
    width: 100%;
    padding: 0 100px 100px;
    box-sizing: border-box;
    background:
      radial-gradient(circle at top, rgba(249, 201, 46, 0.1), transparent 28%),
      linear-gradient(180deg, #0f0f0f 0%, #141414 100%);
  }
  &-content {
    width: 100%;
    max-width: 1520px;
    background: linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(249,247,240,0.95) 100%);
    border: 1px solid rgba(249, 201, 46, 0.2);
    border-radius: 28px;
    box-sizing: border-box;
    padding: 56px;
    margin: -86px auto 0;
    z-index: 9;
    position: relative;
    box-shadow: 0 28px 80px rgba(0, 0, 0, 0.34);

    &-top {
      display: flex;
      align-items: flex-start;
      gap: 52px;

      &-left {
        width: 220px;
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-shrink: 0;

        img {
          width: 132px;
          height: 132px;
          margin-bottom: 16px;
          border-radius: 50%;
          padding: 18px;
          box-sizing: border-box;
          background: linear-gradient(135deg, #151515 0%, #303030 100%);
          box-shadow: 0 18px 40px rgba(0, 0, 0, 0.18);
        }
        span {
          .fontdemo(22px, "PingFangSC,PingFang SC", 600, #111111);
          text-align: center;
          line-height: 1.5;
          word-break: break-all;
        }
      }
      &-right {
        flex: 1;
        text-align: left;

        &-head {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 24px;
          margin-bottom: 28px;

          .title-wrap {
            flex: 1;
            min-width: 0;
          }

          .category-label {
            .fontdemo(14px, "PingFangSC,PingFang SC", 600, #8a7750);
            margin: 0 0 12px;
            letter-spacing: 2px;
          }

          h1 {
            .fontdemo(34px, "PingFangSC,PingFang SC", 600, #111111);
            margin: 0;
            line-height: 1.4;
            word-break: break-all;
          }

          .status-badge {
            min-width: 100px;
            padding: 10px 18px;
            border-radius: 999px;
            text-align: center;
            .fontdemo(14px, "PingFangSC,PingFang SC", 600, #ffffff);
            box-sizing: border-box;
            flex-shrink: 0;

            &.pending {
              background: linear-gradient(135deg, #8d8d8d 0%, #b3b3b3 100%);
            }

            &.pass {
              background: linear-gradient(135deg, #0f9d58 0%, #38c172 100%);
            }

            &.reject {
              background: linear-gradient(135deg, #c93737 0%, #f04747 100%);
            }
          }
        }
      }
    }

    .detail-grid {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 18px;
    }

    .info-card {
      padding: 22px 24px;
      border-radius: 18px;
      background: rgba(255, 255, 255, 0.72);
      border: 1px solid rgba(249, 201, 46, 0.14);
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
      box-sizing: border-box;

      label {
        display: block;
        .fontdemo(14px, "PingFangSC,PingFang SC", 600, #8a7750);
        margin-bottom: 10px;
        letter-spacing: 1px;
      }

      span {
        display: block;
        .fontdemo(17px, "PingFangSC,PingFang SC", 400, rgba(0,0,0,0.78));
        line-height: 1.8;
        word-break: break-all;
      }

      .highlight {
        color: #d89200;
        font-weight: 600;
      }

      &.desc-card,
      &.full {
        grid-column: 1 / -1;
      }
    }
    em {
      width: 100%;
      height: 1px;
      display: block;
      margin: 36px 0 28px;
      background: linear-gradient(90deg, rgba(249, 201, 46, 0.72), rgba(0, 0, 0, 0.08));
      border: none;
    }
    &-imgList {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: 100%;
      &-item {
        width: 24%;
        height: 190px;
        margin-right: 1.333%;
        margin-bottom: 20px;
        position: relative;
        overflow: hidden;
        border-radius: 18px;
        box-shadow: 0 12px 28px rgba(0, 0, 0, 0.16);
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .mask {
          position: absolute;
          left: 0;
          top: 0;
          justify-content: center;
          align-items: center;
          opacity: 0;
          background: rgba(10, 10, 10, 0.58);
          transition: opacity 0.3s;
          width: 100%;
          height: 100%;
          display: flex;
          cursor: pointer;
          .zoom {
            width: 42px;
            height: 42px;
          }
        }
      }
      :nth-child(4n) {
        margin-right: 0;
      }
      &-item:hover .mask {
        opacity: 1;
      }
    }
    .detail-send {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 20px;
      margin-top: 54px;
      flex-wrap: wrap;
    }
    &-send,
    &-pass,
    &-reject,
    &-await {
      width: 200px;
      height: 52px;
      border-radius: 999px;
      margin: 0;
      .fontdemo(16px, "PingFangSC, PingFang SC", 500, #FFFFFF);
      line-height: 52px;
      cursor: pointer;
      text-align: center;
      transition: transform 0.25s ease, box-shadow 0.25s ease, opacity 0.25s ease;

      &:hover {
        transform: translateY(-2px);
      }
    }

    &-send {
      background: linear-gradient(135deg, #141414 0%, #2b2b2b 100%);
      color: #f9c92e;
      border: 1px solid rgba(249, 201, 46, 0.45);
    }

    &-await {
      background: linear-gradient(135deg, #8d8d8d 0%, #b3b3b3 100%);
      color: #ffffff;
    }

    &-pass {
      background: linear-gradient(135deg, #0f9d58 0%, #38c172 100%);
      box-shadow: 0 14px 30px rgba(56, 193, 114, 0.24);
    }
    &-reject {
      background: linear-gradient(135deg, #c93737 0%, #f04747 100%);
      box-shadow: 0 14px 30px rgba(240, 71, 71, 0.24);
    }
  }
}
</style>
